import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChildren, linkedSignal } from '@angular/core';

import { SvgLibraryIcon, IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { ExpandModule, IconsModule } from '@fcom/ui-components';

import { AccordionItemComponent } from './accordion-item.component';

@Component({
  selector: 'fin-accordion-list',
  templateUrl: './accordion-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, IconsModule, ExpandModule],
})
export class AccordionListComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconLibrary = IconLibrary;

  items = contentChildren(AccordionItemComponent);
  openAccordions = linkedSignal<Record<string, boolean>>(() =>
    Object.fromEntries(this.items().map((item) => [item.key(), false]))
  );

  toggleOpen(item: AccordionItemComponent): void {
    this.openAccordions.update((states) => ({ ...states, [item.key()]: !states[item.key()] }));
  }

  isOpen(item: AccordionItemComponent): boolean {
    return this.openAccordions()[item.key()];
  }
}
